// extracted by mini-css-extract-plugin
export default {"body":"Transfers_body__C0QPD","transfers":"Transfers_transfers__8oykH"};